export const contactFields = [
  'job',
  'name',
  'cellphone',
  'telphone',
  'mail',
  'fax',
  'mainFlag',
];
export const qualificationFields = [
  'certificationType',
  'certificationNumber',
  'certificationName',
  'certificationStartDate',
  'certificationEndDate',
  'annualInspection',
  'attachments',
  'remark',
];
